export default "__VITE_ASSET__BMX$d_pk__"